import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { Button, Menu, MenuItem, Stack } from "@mui/material";
import {
  deleteContentGenre as deleteContentGenreAction
} from "../../actions/content_genres";
import {
  listContentGenres as listContentGenresSelector
} from "../../selectors/content_genres";
import { addToast as addToastAction } from "../../actions/toasts";

import EditContentGenresModal from "../ContentGenresModal/EditContentGenresModal";
import DeleteObjectsModal from "../GlobalObjectsModal/deleteObjectsModal";

import DataTable from "../DataTable";

class ContentGenres extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentGenre: null,

      selectedContentGenresIds: [],

      modalOpened: false,
      menuAnchorEl: null,
      openedMenu: null,
      deleteModalOpened: false
    };

    this.deleteGenre = this.deleteGenre.bind(this);
  }

  setSelectedContentGenresIds = newSelection => {
    this.setState({
      selectedContentGenresIds: newSelection,
    });
  };

  /* Menus methods */

  setMenuAnchorEl = target => {
    this.setState({
      menuAnchorEl: target
    });
  };

  setOpenedMenu = menuId => {
    this.setState({
      openedMenu: menuId
    });
  };

  openMenu = (event, menuId) => {
    this.setMenuAnchorEl(event.currentTarget);
    this.setOpenedMenu(menuId);
  };
  closeMenu = menuId => {
    this.setMenuAnchorEl(null);
    this.setOpenedMenu(menuId);
  };

  /* Modal */

  openEditModal = currentGenre => {
    this.setState({
      currentGenre,
      modalOpened: true
    });
  };

  closeEditModal = () => {
    this.setState({
      currentGenre: null,
      modalOpened: false
    });
  };

  closeDeleteModal = () => {
    this.setState({
      deleteModalOpened: false
    });
  };

  async deleteGenre(selectedGenres) {
    const { deleteContentGenre, addToast } = this.props;

    if (selectedGenres.length > 0) {
      let deleted = 0;

      for (let i = 0; i < selectedGenres.length; i += 1) {
        const selectedOb = selectedGenres[i];
        const ret = await deleteContentGenre(selectedOb);

        if (ret.isSuccess) {
          deleted += 1;
        }
      }

      if (deleted === selectedGenres.length) {
        addToast("success", "Success", "Genre(s) successfully deleted!");
      } else if (deleted === 0) {
        addToast("error", "Error", "Genre(s) cannot be deleted. Try again.");
      } else {
        addToast("warning", "Warning", "Some genre(s) cannot be deleted. Try again.");
      }

      this.setState({
        selectedContentGenresIds: [],
        deleteModalOpened: false
      });
    }
  }

  render() {
    const {
      currentGenre,
      modalOpened,
      selectedContentGenresIds,
      menuAnchorEl,
      openedMenu,
      deleteModalOpened
    } = this.state;

    const {
      contentGenres
    } = this.props;

    const contentGenresFilter = contentGenres.filter(contentGenre => contentGenre.genre_type === "content");

    const menuOpen = Boolean(menuAnchorEl);

    const getLocale = (params, localeName) => params.row.locales[localeName] ? params.row.locales[localeName].name : "";

    return (
      <Stack spacing={2}>
        <div>
          <Button
            id="actions-button"
            sx={{
              borderColor: "primary.smokeBorder",
            }}
            variant="outlined"
            aria-controls={menuOpen && openedMenu === "actions-menu" ? "actions-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen && openedMenu === "actions-menu" ? "true" : undefined}
            disableElevation
            onClick={e => this.openMenu(e, "actions-menu")}
            endIcon={<KeyboardArrowDownIcon />}
            disabled={ selectedContentGenresIds.length <= 0 }
          >
            Actions
          </Button>
          <Menu
            MenuListProps={{
              "aria-labelledby": "actions-button",
            }}
            id="actions-menu"
            anchorEl={menuAnchorEl}
            open={menuOpen && openedMenu === "actions-menu"}
            onClose={() => this.closeMenu()}
          >
            <MenuItem
              sx={{
                color: "red"
              }}
              onClick={() => {
                this.closeMenu();
                this.setState({
                  deleteModalOpened: true
                });
              }}
              disableRipple
            >
              Delete selected content genres
            </MenuItem>
          </Menu>
        </div>
        <div style={{ height: "calc(100vh - 270px)", minHeight: "160px" }}>
          <DataTable
            cols={[
              { headerName: "Id", field: "id", flex: 1 },
              { headerName: "EN", field: "en", flex: 1, valueGetter: params => getLocale(params, "en_GB") },
              { headerName: "FR", field: "fr", flex: 1, valueGetter: params => getLocale(params, "fr_FR") },
              { headerName: "AR", field: "ar", flex: 1, valueGetter: params => getLocale(params, "ar_AR") },
              { headerName: "RU", field: "ru", flex: 1, valueGetter: params => getLocale(params, "ru_RU") },
              { headerName: "Modified", field: "updated_at", flex: 1 }
            ]}
            data={contentGenresFilter}
            onRowClick={id => this.openEditModal(id)}
            onRowSelectionModelChange={this.setSelectedContentGenresIds}
            checkboxSelection
            pagination
          />
        </div>

        {/* MODAL */}

        <EditContentGenresModal
          genreId={currentGenre?.id}
          modalOpened={modalOpened}
          closeEditModal={this.closeEditModal}
        />

        <DeleteObjectsModal
          selectedIds={selectedContentGenresIds}
          modalOpened={deleteModalOpened}
          deleteObjects={this.deleteGenre}
          closeDeleteModal={this.closeDeleteModal}
          name="Content genres"
        />
      </Stack>
    );
  }
}

ContentGenres.propTypes = {
  contentGenres: PropTypes.arrayOf(PropTypes.object).isRequired,

  deleteContentGenre: PropTypes.func.isRequired,
  addToast: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    contentGenres: listContentGenresSelector(state),
  };
}

const mapDispatchToProps = {
  deleteContentGenre: deleteContentGenreAction,
  addToast: addToastAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentGenres);
